import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemComponent } from '../item/item.component';
import { BodyRequest, ItemType } from '../formulario/request.model';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { EstadoPanelComponent } from '../ui/estado-panel.component';
import { Filter } from '../formulario/filter-model';

@Component({
  selector: 'app-listado',
  standalone: true,
  imports: [ItemComponent, NgxPaginationModule, ReactiveFormsModule, CommonModule, SpinnerComponent, EstadoPanelComponent],
  templateUrl: './listado.component.html',
  styleUrl: './listado.component.scss'
})
export class ListadoComponent implements OnInit {
  Boolean = Boolean;
  p: number = 1;
  @Input() items!: BodyRequest[];
  itemsToShow: BodyRequest[] = this.items;

  @Input()
  filter!: Filter[];

  @Input()
  showFilter: boolean = true;

  @Input()
  itemsPerPage: number = 30;

  @Input()
  marginPagination: boolean = true;

  /** Listado principal de una sección: guarda la búsqueda (?q=) y la página (?p=) en la URL para recuperarlas al volver. */
  @Input()
  persistirEstado: boolean = false;

  @Input()
  type!: ItemType;
  ItemType = ItemType;

  @Output()
  openItem = new EventEmitter<BodyRequest>();

  @Output()
  deleteItem = new EventEmitter<BodyRequest>();

  searchControl = new FormControl();

  showSearchBar: ItemType[] = [ItemType.ASOCIACIONES, ItemType.ASOCIADOS, ItemType.HISTORICO];
  largeListScrollBar: ItemType[] = [ItemType.CARGOS, ItemType.EJERCICIOS, ItemType.CARGOASOCIADOASOCIACION];
  loading: boolean = true;

  constructor(@Optional() private router?: Router, @Optional() private route?: ActivatedRoute) {}

  ngOnInit() {
    if (!this.persistirEstado || !this.route) return;
    const parametros = this.route.snapshot.queryParamMap;
    const texto = (parametros.get('q') ?? '').slice(0, 100);
    const pagina = Number(parametros.get('p'));
    if (texto) { this.searchControl.setValue(texto); this.aplicarBusqueda(texto.toLowerCase()); }
    if (Number.isInteger(pagina) && pagina > 1) this.p = pagina;
  }

  ngOnChanges() {
    this.loading = true;
    this.itemsToShow = this.items;
    this.checkConditions();
    if (this.persistirEstado && (this.searchControl.value ?? '') !== '') this.aplicarBusqueda(String(this.searchControl.value).toLowerCase());
    this.loading = false;
  }

  cambiarPagina(pagina: number) {
    this.p = pagina;
    this.guardarEstado();
  }

  private guardarEstado() {
    if (!this.persistirEstado || !this.router || !this.route) return;
    const texto = String(this.searchControl.value ?? '').trim();
    this.router.navigate([], { relativeTo: this.route, replaceUrl: true, queryParamsHandling: 'merge', queryParams: { q: texto || null, p: this.p > 1 ? this.p : null } });
  }

  filterItems(evento: any) {
    const valor = (evento.target as HTMLInputElement).value.toLowerCase();
    this.p = 1;
    this.aplicarBusqueda(valor);
    this.guardarEstado();
  }

  private aplicarBusqueda(value: string) {
    if (this.type === ItemType.ASOCIACIONES) {
      this.itemsToShow = this.items.filter(item => {
        const nombre = item.nombre ? item.nombre.toLowerCase() : '';
        const lema = item.lema ? item.lema.toLowerCase() : '';
        return item.id === Number(value) || nombre.includes(value) || lema.includes(value);
      });
    }

    if (this.type === ItemType.ASOCIADOS) {
      this.itemsToShow = this.items.filter(item => {
        const nombre = item.nombre ? item.nombre.toLowerCase() : '';
        const apellidos = item.apellidos ? item.apellidos.toLowerCase() : '';
        const nombreCompleto = `${nombre} ${apellidos}`;
        const nif = item.nif ? item.nif.toLowerCase() : '';
        return nombreCompleto.includes(value) || nif.includes(value);
      });
    }
  }

  checkConditions() {
    if (Boolean(this.filter) && this.filter.length > 0) {
      this.itemsToShow = this.items.filter(item => {
        let check = true;
        for (let condition of this.filter) {
          if (item[condition.name] !== condition.condition){
            check = false;
          }
        }
        return check
      })
    }
  }

}
